import {useEffect} from "react";
import {useFetchHook} from "../../../hooks/useFetchHook";
import fetcher from "../../../fetcher";

// Fetches a single listing by id. The backend serves the flattened listing
// object directly as the response body (no envelope). `response.data` is the
// axios response; its `.data` is that body.
export const useListingDetail = (id) => {
    const [response, fetchListing] = useFetchHook(fetcher.getListing)

    useEffect(function fetchOnIdChange(){
        if (id) fetchListing(id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const listing = response.data?.data || null

    return {
        listing,
        loading: response.loading,
        error: response.error,
    }
}
